import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import vuetify from './plugins/vuetify'
import './plugins/axios'
import './plugins/mask'
import './plugins/date'
import './plugins/filter'
import './plugins/veevalidate'
import './plugins/offline'
import './plugins/scroll'
import './plugins/number'
import './plugins/image'
import './plugins/string'
import './plugins/clipboard'
import '@babel/polyfill'

// vue custom filters
import './util/filter'

Vue.config.productionTip = false

export const eventBus = new Vue()

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
